// extracted by mini-css-extract-plugin
var _1 = "upZ27YDj";
export { _1 as "control" }
